import { User } from "../../models/interfaces/auth.interface";

export interface SessionState {
  user: User | null;
}

export function createInitialSessionState(): SessionState {
  return {
    user: {
      firstName: '',
      lastName: '',
      token: ''
    }
  }
}

export function createSession(user: User) {
    return {...user};
}
